import {useEffect} from 'react'
// import DeliveryTypeEditModalFormWrapper from './DeliveryTypeEditModalFormWrapper'
import ModalHeader from './ModalHeader'
import ModalWrapper from './ModalWrapper'


const Modal = () => {
  useEffect(() => {
    document.body.classList.add('modal-open')
    return () => {
      document.body.classList.remove('modal-open')
    }
  }, [])

  return (
    <>
      <div
        className='modal fade show d-block'
        id='kt_modal_add_user'
        role='dialog'
        tabIndex={-1}
        aria-modal='true'
      >
        {/* begin::Modal dialog */}
        <div className='modal-dialog modal-dialog-centered mw-800px'>
          {/* begin::Modal content */}
          <div className='modal-content'>
            <ModalHeader />
            {/* begin::Modal body */}
            <div className='modal-body scroll-y'>
              <ModalWrapper  />
            </div>
            {/* end::Modal body */}
          </div>
          {/* end::Modal content */}
        </div>
        {/* end::Modal dialog */}
      </div>
      {/* begin::Modal Backdrop */}
      <div className='modal-backdrop fade show'></div>
      {/* end::Modal Backdrop */}
    </>
  )
}

export default Modal
